import ApiDescriptionPage from './ApiDescriptionPage';

export default ApiDescriptionPage;
